import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_sales_commission_report_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  mlm_program_guid: fromDatatype.GuidDataFieldInterface;
  mlm_downline_entity_guid: fromDatatype.GuidDataFieldInterface;
  mlm_downline_program_participant_guid: fromDatatype.GuidDataFieldInterface;
  mlm_downline_membership_guid: fromDatatype.GuidDataFieldInterface;
  mlm_downline_commission_hdr_guid: fromDatatype.GuidDataFieldInterface;
  mlm_downline_commission_line_guid: fromDatatype.GuidDataFieldInterface;
  sales_doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_doc_membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  purchase_item_guid: fromDatatype.GuidDataFieldInterface;
  sales_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  sales_doc_line_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  sales_doc_comp_guid: fromDatatype.GuidDataFieldInterface;
  sales_doc_branch_guid: fromDatatype.GuidDataFieldInterface;
  mlm_downline_lineage_absolute: fromDatatype.NumericDatatypeInterface;
  mlm_downline_lineage_relative: fromDatatype.NumericDatatypeInterface;
  sales_doc_amount_txn: fromDatatype.NumericDatatypeInterface;
  sales_doc_amount_net: fromDatatype.NumericDatatypeInterface;
  sales_doc_amount_cost: fromDatatype.NumericDatatypeInterface;
  commission_money_amount: fromDatatype.NumericDatatypeInterface;
  commission_point_amount: fromDatatype.NumericDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  sales_doc_date_txn: fromDatatype.TimestampTzDatatypeInterface;
  purchase_item_code: fromDatatype.VarcharDatatypeInterface;
  sales_doc_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  sales_doc_reference_no: fromDatatype.VarcharDatatypeInterface;
  sales_doc_server_doc_1: fromDatatype.VarcharDatatypeInterface;
  sales_doc_server_doc_2: fromDatatype.VarcharDatatypeInterface;
  sales_doc_server_doc_3: fromDatatype.VarcharDatatypeInterface;
  sales_doc_server_doc_4: fromDatatype.VarcharDatatypeInterface;
  sales_doc_server_doc_5: fromDatatype.VarcharDatatypeInterface;
  commission_money_currency: fromDatatype.VarcharDatatypeInterface;
  commission_point_currency: fromDatatype.VarcharDatatypeInterface;
  client_status_01: fromDatatype.VarcharDatatypeInterface;
  client_status_02: fromDatatype.VarcharDatatypeInterface;
  client_status_03: fromDatatype.VarcharDatatypeInterface;
  client_status_04: fromDatatype.VarcharDatatypeInterface;
  client_status_05: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  calculation_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  commission_date_valid_from: fromDatatype.TimestampTzDatatypeInterface;
  commission_date_valid_to: fromDatatype.TimestampTzDatatypeInterface;
  commission_validity_duration_in_day: fromDatatype.NumericDatatypeInterface;
}

export class bl_fi_sales_commission_report_line_RowClass
  implements bl_fi_sales_commission_report_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    mlm_program_guid: fromDatatype.GuidDataFieldInterface;
    mlm_downline_entity_guid: fromDatatype.GuidDataFieldInterface;
    mlm_downline_program_participant_guid: fromDatatype.GuidDataFieldInterface;
    mlm_downline_membership_guid: fromDatatype.GuidDataFieldInterface;
    mlm_downline_commission_hdr_guid: fromDatatype.GuidDataFieldInterface;
    mlm_downline_commission_line_guid: fromDatatype.GuidDataFieldInterface;
    sales_doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    sales_doc_membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
    purchase_item_guid: fromDatatype.GuidDataFieldInterface;
    sales_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    sales_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    sales_doc_line_fi_item_guid: fromDatatype.GuidDataFieldInterface;
    sales_doc_comp_guid: fromDatatype.GuidDataFieldInterface;
    sales_doc_branch_guid: fromDatatype.GuidDataFieldInterface;
    mlm_downline_lineage_absolute: fromDatatype.NumericDatatypeInterface;
    mlm_downline_lineage_relative: fromDatatype.NumericDatatypeInterface;
    sales_doc_amount_txn: fromDatatype.NumericDatatypeInterface;
    sales_doc_amount_net: fromDatatype.NumericDatatypeInterface;
    sales_doc_amount_cost: fromDatatype.NumericDatatypeInterface;
    commission_money_amount: fromDatatype.NumericDatatypeInterface;
    commission_point_amount: fromDatatype.NumericDatatypeInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    sales_doc_date_txn: fromDatatype.TimestampTzDatatypeInterface;
    purchase_item_code: fromDatatype.VarcharDatatypeInterface;
    sales_doc_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    sales_doc_reference_no: fromDatatype.VarcharDatatypeInterface;
    sales_doc_server_doc_1: fromDatatype.VarcharDatatypeInterface;
    sales_doc_server_doc_2: fromDatatype.VarcharDatatypeInterface;
    sales_doc_server_doc_3: fromDatatype.VarcharDatatypeInterface;
    sales_doc_server_doc_4: fromDatatype.VarcharDatatypeInterface;
    sales_doc_server_doc_5: fromDatatype.VarcharDatatypeInterface;
    commission_money_currency: fromDatatype.VarcharDatatypeInterface;
    commission_point_currency: fromDatatype.VarcharDatatypeInterface;
    client_status_01: fromDatatype.VarcharDatatypeInterface;
    client_status_02: fromDatatype.VarcharDatatypeInterface;
    client_status_03: fromDatatype.VarcharDatatypeInterface;
    client_status_04: fromDatatype.VarcharDatatypeInterface;
    client_status_05: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    calculation_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    commission_date_valid_from: fromDatatype.TimestampTzDatatypeInterface;
    commission_date_valid_to: fromDatatype.TimestampTzDatatypeInterface;
    commission_validity_duration_in_day: fromDatatype.NumericDatatypeInterface;
}
